function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#cl)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M181.75 235L242.511 219.283L263.711 314.051L426.974 305.372L440.087 372.304L425.51 367.72C159.126 487.137 181.75 235 181.75 235Z",
  fill: "#C9256A"
}), /*#__PURE__*/React.createElement("path", {
  d: "M209.596 231.972L284.752 190.064L319.679 286.464L405.823 524.216L343.211 546.902L344.839 531.33L209.596 231.972Z",
  fill: "#EE5998"
}), /*#__PURE__*/React.createElement("path", {
  d: "M344.84 531.331L209.596 231.972",
  stroke: "#131313",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M149.698 66.0669L153.998 77.9429C155.615 82.4052 158.681 86.1965 162.707 88.7107C166.732 91.2249 171.485 92.3168 176.204 91.8119L196.785 89.6119L179.964 43.1759L162.85 45.0079C160.472 45.2624 158.182 46.0544 156.155 47.3241C154.128 48.5938 152.416 50.3079 151.149 52.3367C149.882 54.3655 149.093 56.6559 148.842 59.0346C148.59 61.4133 148.883 63.8181 149.698 66.0669V66.0669Z",
  fill: "#FFD5E7"
}), /*#__PURE__*/React.createElement("path", {
  d: "M154.001 77.9419C155.618 82.4042 158.684 86.1955 162.71 88.7097C166.735 91.2239 171.488 92.3158 176.207 91.8109L196.788 89.6109",
  stroke: "#131313",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M172.071 68.6669C172.606 68.6669 173.04 68.233 173.04 67.6979C173.04 67.1627 172.606 66.7289 172.071 66.7289C171.536 66.7289 171.102 67.1627 171.102 67.6979C171.102 68.233 171.536 68.6669 172.071 68.6669Z",
  fill: "#131313"
}), /*#__PURE__*/React.createElement("path", {
  d: "M158.073 73.7389C158.608 73.7389 159.042 73.3051 159.042 72.7699C159.042 72.2347 158.608 71.8009 158.073 71.8009C157.538 71.8009 157.104 72.2347 157.104 72.7699C157.104 73.3051 157.538 73.7389 158.073 73.7389Z",
  fill: "#131313"
}), /*#__PURE__*/React.createElement("path", {
  d: "M164.15 76.7189L159.061 62.674L152.025 65.2229",
  stroke: "#131313",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M170.67 58.4679L163.634 61.0169",
  stroke: "#131313",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M184.146 61.7259L185.913 66.6029C187.176 66.1451 188.206 65.2043 188.776 63.9874C189.345 62.7706 189.408 61.3772 188.951 60.1139C188.898 59.9679 188.839 59.8259 188.774 59.6879C187.436 56.8259 183.07 58.7559 184.146 61.7259Z",
  fill: "#FFD5E7"
}), /*#__PURE__*/React.createElement("path", {
  d: "M185.908 66.6029C187.171 66.1451 188.201 65.2044 188.771 63.9875C189.34 62.7706 189.404 61.3773 188.946 60.1139",
  stroke: "#131313",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M168.592 79.6989C168.991 79.8858 169.423 79.9923 169.863 80.0123C170.303 80.0322 170.743 79.9652 171.157 79.8152C171.572 79.6651 171.952 79.4349 172.278 79.1376C172.603 78.8404 172.866 78.482 173.053 78.0829",
  stroke: "#131313",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M164.154 76.7298L167.505 76.3708",
  stroke: "#131313",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M147.155 62.382C147.155 62.382 156.183 60.201 156.971 52.101C156.971 52.101 163.571 57.5339 175.909 53.9679C175.909 53.9679 179.067 61.096 184.145 61.727",
  stroke: "#131313",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M150.371 71.2599C150.371 71.2599 132.117 69.6989 138.113 53.4769C144.109 37.2549 176.824 18.3769 193.622 38.8209C209.902 58.6359 191.739 75.2439 191.739 75.2439",
  stroke: "#131313",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M187.571 28.475C187.571 28.475 194.837 31.475 196.115 37.01",
  stroke: "#EE5998",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M191.416 27.0819L196.172 5.06494C196.172 5.06494 222.601 7.11894 216.809 33.9339L198.746 34.9059",
  stroke: "#131313",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M187.571 96.9249C187.571 96.9249 180.758 100.136 107.928 86.6379C35.0981 73.1399 0.085075 68.1269 7.12808 73.5379C14.1711 78.9489 22.4181 84.9059 22.4181 84.9059C22.4181 84.9059 33.892 106.234 51.471 98.1679C51.471 98.1679 143.821 135.868 170.671 155.751",
  stroke: "#131313",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M154.782 160.57L181.75 235.001L296.581 222.713L266.546 139.813C261.371 125.53 251.556 113.395 238.671 105.347C225.787 97.2995 210.575 93.8045 195.47 95.4209V95.4209C188.112 96.2083 181.03 98.6586 174.758 102.587C168.487 106.515 163.191 111.817 159.272 118.094C155.352 124.37 152.911 131.456 152.133 138.815C151.355 146.173 152.261 153.613 154.782 160.57V160.57Z",
  fill: "#AC7FE0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M218.229 96.4779C218.229 96.4779 288.317 119.556 299.521 189.866C310.725 260.176 163.172 252.602 150.604 211.736C150.604 211.736 135.815 205.436 141.37 203.965C146.925 202.494 252.909 192.272 252.909 192.272L219.628 162.195",
  stroke: "#131313",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "cl"
}, /*#__PURE__*/React.createElement("rect", {
  width: 272.64,
  height: 405.265,
  fill: "white"
})));

var SvgCaseLady = function SvgCaseLady(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 273,
    height: 406,
    viewBox: "0 0 273 406",
    fill: "none",
    className: "hidden md:block absolute right-0 bottom-0 mb-96",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCaseLady, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/CaseLady.48bfe31d.svg";
export { ForwardRef as ReactComponent };